import { render, staticRenderFns } from "./list-GST.vue?vue&type=template&id=3d710be5&"
import script from "./list-GST.vue?vue&type=script&lang=js&"
export * from "./list-GST.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports